import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    max-width: ${theme.grid.container};
    margin: 0 auto;

    display: flex;
    flex-direction: column;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 1.31rem;
    font-weight: 500;
    color: ${theme.colors.dark_background};
    align-self: center;
    margin-top: 1rem;
    margin-bottom: 2.5rem;
    text-align: center;

    strong {
      color: ${theme.colors.primary};
      font-weight: 600;
    }
  `}
`;

export const SubTitle = styled.h2`
  ${({ theme }) => css`
    font-size: 1rem;
    text-align: center;
    font-weight: 400;
    color: ${theme.colors.dark_background};
    align-self: center;

    strong {
      font-weight: 500;
    }
  `}
`;

export const WrapperResults = styled.div`
  margin-top: 1.5rem;

  display: flex;
  justify-content: center;
  gap: 3rem;

  flex-wrap: wrap;

  @media (max-width: 1010px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const ResultItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      font-weight: 500;
      font-size: 1rem;
    }

    span {
      font-weight: 600;
      font-size: 1.31rem;
      color: ${theme.colors.primary};
    }
  `}
`;

export const WrapperButtons = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 3rem;
`;

export const WrapperTerms = styled.div`
  text-align: center;
  margin-top: 3.12rem;
  margin-bottom: 2.5rem;

  p {
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    margin-bottom: 0.5rem;
  }
`;

export const WrapperBanks = styled.div`
  ${({ theme }) => css`
    margin-bottom: 2rem;
    margin: 0 auto;

    display: flex;
    justify-content: center;
    gap: 1.5rem;

    @media (max-width: ${theme.breakpoints.xxlarge}) {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: ${theme.breakpoints.large}) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: ${theme.breakpoints.small}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${theme.breakpoints.xsmall}) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;

export const BankItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-bottom: -5px;
  }

  div {
    strong {
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.5rem;
    }

    p {
      font-size: 0.87rem;
      font-weight: 400;
      line-height: 1.5rem;
      margin-top: -0.4rem;
    }
  }
`;
